import { env } from '@env'
import axios from 'axios'

const cmsApi = axios.create()

const apiURL = env.CMS_API_BASE_URL

cmsApi.defaults.baseURL = apiURL

//* All request will wait 3 seconds before timeout
cmsApi.defaults.timeout = 30000
cmsApi.defaults.withCredentials = false

export { cmsApi }
